export const cancellationError = "cancellation"
export const needsUpgradeError = "User needs upgrade"
export const knownErrors = [cancellationError, needsUpgradeError]
